import axiosInstance from "@/lib/axiosInstance";
import { notificationsEndpoints } from "./notifications.endpoints";
import type { NotificationsListParams, NotificationsListResponse } from "./notifications.types";

export const NotificationsQueryKeys = {
  list: "notificationsList",
  unreadCount: "notificationsUnreadCount",
} as const;

export const getNotifications = async (
  params: NotificationsListParams,
  signal?: AbortSignal,
): Promise<NotificationsListResponse["data"]> => {
  const searchParams = new URLSearchParams();
  searchParams.append("page", String(params.page ?? 1));
  searchParams.append("limit", String(params.limit ?? 20));
  if (params.isRead !== undefined) {
    searchParams.append("isRead", String(params.isRead));
  }

  const response = await axiosInstance.get<NotificationsListResponse>(
    `${notificationsEndpoints.list()}?${searchParams.toString()}`,
    { signal },
  );
  return response.data.data;
};
